import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Mail, DollarSign, Phone, MessageCircle } from 'lucide-react';

interface CTABlockProps {
  onRequestQuote: () => void;
  onMakeOffer: () => void;
  onContact: () => void;
}

export const CTABlock = ({ onRequestQuote, onMakeOffer, onContact }: CTABlockProps) => {
  return (
    <Card className="bg-gradient-to-r from-primary/10 to-primary/5 border-primary/20">
      <CardContent className="p-8 text-center space-y-6">
        <div>
          <h2 className="text-2xl font-bold mb-2">Intéressé par ce véhicule ?</h2>
          <p className="text-muted-foreground">
            Contactez-nous dès maintenant pour plus d'informations ou pour planifier une visite
          </p>
        </div>

        <div className="grid sm:grid-cols-2 gap-4">
          <Button 
            onClick={onRequestQuote}
            size="lg"
            className="w-full"
          >
            <Mail className="mr-2 h-5 w-5" />
            Demander un devis
          </Button>

          <Button 
            onClick={onMakeOffer}
            size="lg"
            variant="outline"
            className="w-full"
          >
            <DollarSign className="mr-2 h-5 w-5" />
            Faire une offre
          </Button>

          <Button 
            onClick={onContact}
            size="lg"
            variant="outline"
            className="w-full"
          >
            <Phone className="mr-2 h-5 w-5" />
            Nous contacter
          </Button>

          <Button 
            asChild
            size="lg"
            variant="outline"
            className="w-full bg-green-50 hover:bg-green-100 border-green-200"
          >
            <a 
              href="https://wa.me/33608248529" 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex items-center justify-center"
            >
              <MessageCircle className="mr-2 h-5 w-5" />
              WhatsApp
            </a>
          </Button>
        </div>

        {/* Informations légales */}
        <div className="pt-6 border-t text-sm text-muted-foreground space-y-1">
          <p className="font-semibold text-foreground">Trucks52 SARL</p>
          <p>2 Place de l'Église, Recourt - 52140 Val-de-Meuse</p>
          <p>Tél: 06 08 24 85 29 | Email: trucks.52@orange.fr</p>
          <p className="text-xs mt-2">SIRET: 508 009 495 00013</p>
        </div>
      </CardContent>
    </Card>
  );
};
